<div #contents></div>
@if (loadFailed) {
  <p>{{ translateKey + 'load_failed' | translate }}</p>
}
